import { render, staticRenderFns } from "./MasterCreatedGroup.vue?vue&type=template&id=650ef7b3"
import script from "./MasterCreatedGroup.vue?vue&type=script&lang=js"
export * from "./MasterCreatedGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports